// Data Hub landing page — shows the Data Registry (default tab)

import { createFileRoute } from '@tanstack/react-router';

import { DataHubLayout } from '@/features/datahub/components/DataHubLayout';
import { DataRegistryPage } from '@/features/datahub/components/DataRegistryPage';

export const Route = createFileRoute('/_authenticated/datahub/')({
  component: DataHubIndexPage,
});

function DataHubIndexPage() {
  return (
    <DataHubLayout activeTab="registry">
      <DataRegistryPage />
    </DataHubLayout>
  );
}
